import React, { FC, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import Grid from '@material-ui/core/Grid/Grid';

import { IProps } from './IUserStatisticCont';
import locales from '../../locales';
import UserStatisticTable from '../../components/UserStatistic/UserStatisticTable';
import UserCard from '../../components/UserStatistic/UserCard';
import UserReserveTable from '../../components/UserStatistic/UserReserveTable';
import BackButton from '../../components/Common/BackButton';
import PageHeaderWrap from '../../components/Common/PageHeaderWrap';
import PageContentWrap from '../../components/Common/PageContentWrap';
import CashBoxWarningCont from '../CashBoxWarning';
import { getUserStatistic } from "../../actions/userStatistic/UserStatisticActions";
import { openBookingDetails } from "../../actions/statistics/StatisticsActions";

export const UserStatistic: FC<IProps> = ({ phone }) => {
  const [sortType, changeSortType] = useState<"desc" | "asc">('desc');
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(10);

  const dispatch = useDispatch();

  const moneySymbol = useSelector((state: any) => state.cabinet.moneySymbol);
  const statistic = useSelector((state: any) => state.userStatistics.statistics);
  const reserves = useSelector((state: any) => state.userStatistics.reserves);
  const userInfo = useSelector((state: any) => state.userStatistics.userInfo);
  const loading = useSelector((state: any) => state.loading.isLoading);
  const bookingsOrders = useSelector((state: any) => state.statistic.bookingsOrders);

  useEffect(() => {
    dispatch(getUserStatistic(phone, { orderBy: 'date', order: sortType }, page, pageSize));
  }, [dispatch, phone]);

  const handleChangeSort = (order: 'desc' | 'asc') => {
    changeSortType(order)
    dispatch(getUserStatistic(phone, { orderBy: 'date', order }, page, pageSize));
  };

  const handleOpenBookingDetails = (bookingId: number) => {
    dispatch(openBookingDetails(bookingId));
  };

  const handleChangePage = (page: number) => {
    setPage(page)
    dispatch(getUserStatistic(phone, { orderBy: 'date', order: sortType }, page, pageSize));

  }
  const handleChangePageSize = (pageSize: number) => {
    setPageSize(pageSize)
    dispatch(getUserStatistic(phone, { orderBy: 'date', order: sortType }, page, pageSize));

  }

  return (
    <>
      <PageHeaderWrap>
        <BackButton text={locales.t('userStatistic.title')} />
      </PageHeaderWrap>
      <CashBoxWarningCont />
      {!loading && (
        <PageContentWrap fullWidth>
          <Grid item xs={12} md={6}>
            <UserCard
              userInfo={userInfo}
              statistic={statistic}
              moneySymbol={moneySymbol}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <UserStatisticTable statistic={statistic} />
          </Grid>
          <Grid item xs={12}>
            <UserReserveTable
              reserves={reserves}
              bookingsOrders={bookingsOrders}
              moneySymbol={moneySymbol}
              page={page}
              pageSize={pageSize}
              sortType={sortType}
              onChangeSort={handleChangeSort}
              onOpenBookingDetails={handleOpenBookingDetails}
              onChangePage={handleChangePage}
              onChangePageSize={handleChangePageSize}
            />
          </Grid>
        </PageContentWrap>
      )}
    </>
  );
};